import { Button, Divider, Flex, Space, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Icon from "../../../Icon"

const { Text } = Typography

const AnotherProviderBanner = ({ handleCloseProviderBanner }) => {
  const { t } = useTranslation()

  return (
    <>
      <Flex
        vertical
        gap={12}
        style={{ width: 200, fontWeight: 400 }}
        className="additional-message-block"
      >
        <Flex data-tour="demo-mode-banner" vertical gap={12}>
          <Icon className="lock-icon" type="square_info_orange" />
          <Space size={4} direction="vertical">
            <Space size={4}>
              <Text>{t("You’re currently with another provider")}</Text>
            </Space>

            <Text style={{ fontWeight: 400 }} type="secondary">
              {t("To switch, please review the")}{" "}
              <a
                href="https://help.chargeback.io/en/articles/12782794-managing-provider-transfers-for-chargeback-io"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("provider transfer instructions")}
              </a>{" "}
              {t("to activate")}{" "}
              <a href="https://help.chargeback.io" target="_blank" rel="noopener noreferrer">
                chargeback.io.
              </a>
            </Text>
          </Space>
        </Flex>

        <Button
          className="balance-btn"
          style={{ borderRadius: 6, width: 127 }}
          size="small"
          onClick={handleCloseProviderBanner}
        >
          {t("Don’t show again")}
        </Button>
      </Flex>

      <Divider type="horizontal" style={{ margin: "16px auto" }} />
    </>
  )
}

export default AnotherProviderBanner
